module.exports = __webpack_public_path__ + "media/svg/nav-volta-azul-95f80dda.svg";